const formatNuggetDateTime = (date) => {
    const options = {year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'}
    let formattedDate = new Date(date);
    return formattedDate.toLocaleDateString('en-US', options);
}


export {formatNuggetDateTime}